module.exports = __webpack_public_path__ + "img/icon_lock_remoteClose.4e6914e0.svg";